var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-col',[_c('v-row',[_vm._v(_vm._s(_vm.approval.name))]),_c('v-row',[_vm._v(_vm._s(_vm.toShortDateStr(_vm.approval.date)))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }